import request from '../../src/state/modules/axios'

export function getQuestions(data){
    return request({
        url: '/api/test-questions',
        method: 'get',
        params: data
    })
}

export function showQuestion(id){
    return request({
        url: `/api/test-questions/${id}`,
        method: 'get',
    })
}

export function addQuestion(data){
    return request({
        url:'/api/test-questions',
        method:'post',
        data
    })
}

export function editQuestion(data){
    return request({
        url: `/api/test-questions/${data.get('id')}`,
        method:'post',
        data
    })
}


export function deleteQuestion(data){
    return request({
        url: `/api/test-questions/${data.id}`,
        method: 'delete'
    })
}
